// Sleep state (enum)
export enum UserSegmentSleepState {
  sleep = "sleep",
  awake = "awake",
  nap = "nap",
}

// SleepUserSegment model
export class SleepUserSegment {
  objectId: string;

  start: Date;
  end: Date;
  startTimeString: string;
  endTimeString: string;
  state: UserSegmentSleepState;

  constructor(start: Date, end: Date, state: UserSegmentSleepState) {
    // Generate random ID like Firebase push key
    this.objectId = this.generateId();
    this.start = start;
    this.end = end;
    this.startTimeString = start.toISOString();
    this.endTimeString = end.toISOString();
    this.state = state;
  }

  static fromJson(data: any, key: string): SleepUserSegment {
    const start = data.start ? new Date(data.start) : new Date();
    const end = data.end ? new Date(data.end) : new Date();

    const state = (data.state as UserSegmentSleepState) ?? UserSegmentSleepState.sleep;

    const seg = new SleepUserSegment(start, end, state);
    seg.objectId = key || seg.generateId();
    seg.startTimeString = data.startTime ?? start.toISOString();
    seg.endTimeString = data.endTime ?? end.toISOString();
    return seg;
  }

  toJson(): Record<string, any> {
    return {
      start: this.start.getTime(),
      end: this.end.getTime(),
      startTime: this.startTimeString,
      endTime: this.endTimeString,
      state: this.state,
    };
  }

  private generateId(): string {
    return Math.random().toString(36).substring(2, 12); // fake Firebase key
  }
}
